module.exports = __webpack_public_path__ + "img/talk.239a9aaf.png";